import * as React from 'react'
import Box from '@mui/material/Box'

// components
import Navbar from '../components/Navbar'
import Hero from '../components/services/Hero'
import Chiffre from '../components/services/Chiffre';
import Difference from '../components/services/Difference'
import Parcours from '../components/services/Parcours'
import Savoir from '../components/services/Savoir'
import Avis from '../components/services/Avis'
import Footer from '../components/Footer'


export default function ServicesPage() {
  return (
    <>
      {/* Navbar globale */}
      <Navbar />
      <Hero />
      <Parcours/>
      <Difference/> 
      <Savoir/>
      <Chiffre /> 
      {/* <Avis/> */}
      <Footer/>
    </>
  )
}